import { render, staticRenderFns } from "./BarWithGrouping.vue?vue&type=template&id=1b38e17c"
import script from "./BarWithGrouping.vue?vue&type=script&lang=js"
export * from "./BarWithGrouping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports